import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import { SocialIconProps } from './icon-atoms.types';

export const SocialIcon: React.FC<SocialIconProps> = ({
  type,
  alt = '',
  width = '32',
  height = '32',
  fill = vars.coreDarkGrey,
  viewBox = '0 0 32 32',
  className,
}) => {
  switch (type) {
    case 'facebook':
      return (
        <svg
          width={width}
          height={height}
          viewBox={viewBox}
          fill={fill}
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          data-testid={type}
        >
          <title>{alt}</title>
          <path
            d="M28.6 15.8C28.6 8.73 22.87 3 15.8 3C8.73 3 3 8.73 3 15.8C3 22.19 7.68 27.485 13.8 28.445V19.5H10.55V15.8H13.8V12.98C13.8 9.7725 15.71 8 18.635 8C20.035 8 21.5 8.25 21.5 8.25V11.4H19.885C18.295 11.4 17.8 12.3875 17.8 13.4V15.8H21.35L20.7825 19.5H17.8V28.445C23.92 27.485 28.6 22.19 28.6 15.8Z"
            fill={fill}
          />
          <path
            d="M20.7833 19.5L21.3508 15.8H17.8008V13.4C17.8008 12.3875 18.2958 11.4 19.8858 11.4H21.5008V8.25C21.5008 8.25 20.0358 8 18.6358 8C15.7108 8 13.8008 9.7725 13.8008 12.98V15.8H10.5508V19.5H13.8008V28.445C14.4533 28.5475 15.1208 28.6 15.8008 28.6C16.4808 28.6 17.1483 28.5475 17.8008 28.445V19.5H20.7833Z"
            fill="transparent"
          />
        </svg>
      );
    case 'instagram':
      return (
        <svg
          width={width}
          height={height}
          viewBox={viewBox}
          fill={fill}
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          data-testid={type}
        >
          <title>{alt}</title>
          <rect width="48" height="48" rx="2" fill="none" />
          <path
            d="M16.0063 5.34249C19.4819 5.34249 19.8935 5.35774 21.2604 5.41871C22.5307 5.47461 23.2167 5.68802 23.674 5.86587C24.2787 6.09961 24.7157 6.38417 25.1679 6.8364C25.6252 7.29372 25.9047 7.72564 26.1384 8.33032C26.3163 8.78764 26.5297 9.4787 26.5856 10.7439C26.6466 12.1159 26.6618 12.5275 26.6618 15.998C26.6618 19.4737 26.6466 19.8853 26.5856 21.2521C26.5297 22.5225 26.3163 23.2085 26.1384 23.6658C25.9047 24.2705 25.6201 24.7074 25.1679 25.1597C24.7106 25.617 24.2787 25.8965 23.674 26.1302C23.2167 26.3081 22.5256 26.5215 21.2604 26.5774C19.8884 26.6384 19.4768 26.6536 16.0063 26.6536C12.5306 26.6536 12.119 26.6384 10.7522 26.5774C9.48183 26.5215 8.79585 26.3081 8.33853 26.1302C7.73385 25.8965 7.29685 25.6119 6.84461 25.1597C6.38729 24.7024 6.10782 24.2705 5.87408 23.6658C5.69623 23.2085 5.48282 22.5174 5.42692 21.2521C5.36595 19.8802 5.3507 19.4686 5.3507 15.998C5.3507 12.5224 5.36595 12.1108 5.42692 10.7439C5.48282 9.47362 5.69623 8.78764 5.87408 8.33032C6.10782 7.72564 6.39238 7.28864 6.84461 6.8364C7.30193 6.37909 7.73385 6.09961 8.33853 5.86587C8.79585 5.68802 9.48691 5.47461 10.7522 5.41871C12.119 5.35774 12.5306 5.34249 16.0063 5.34249ZM16.0063 3C12.4747 3 12.0327 3.01524 10.6455 3.07622C9.26333 3.1372 8.31312 3.36077 7.48994 3.6809C6.6312 4.01627 5.90457 4.45834 5.18302 5.18497C4.45639 5.90652 4.01431 6.63315 3.67895 7.48682C3.35882 8.31507 3.13524 9.2602 3.07427 10.6423C3.01329 12.0346 2.99805 12.4767 2.99805 16.0082C2.99805 19.5397 3.01329 19.9818 3.07427 21.369C3.13524 22.7511 3.35882 23.7013 3.67895 24.5245C4.01431 25.3833 4.45639 26.1099 5.18302 26.8314C5.90457 27.553 6.6312 28.0001 7.48486 28.3304C8.31312 28.6506 9.25825 28.8741 10.6404 28.9351C12.0276 28.9961 12.4696 29.0113 16.0012 29.0113C19.5327 29.0113 19.9748 28.9961 21.362 28.9351C22.7441 28.8741 23.6943 28.6506 24.5175 28.3304C25.3711 28.0001 26.0978 27.553 26.8193 26.8314C27.5409 26.1099 27.988 25.3833 28.3183 24.5296C28.6384 23.7013 28.862 22.7562 28.923 21.3741C28.984 19.9869 28.9992 19.5448 28.9992 16.0133C28.9992 12.4818 28.984 12.0397 28.923 10.6525C28.862 9.27036 28.6384 8.32015 28.3183 7.49698C27.9982 6.63315 27.5561 5.90652 26.8295 5.18497C26.1079 4.46342 25.3813 4.01627 24.5276 3.68598C23.6994 3.36586 22.7543 3.14228 21.3721 3.0813C19.9799 3.01524 19.5378 3 16.0063 3Z"
            fill={fill}
          />
          <path
            d="M16.0062 9.32617C12.3171 9.32617 9.32422 12.3191 9.32422 16.0081C9.32422 19.6972 12.3171 22.6901 16.0062 22.6901C19.6952 22.6901 22.6881 19.6972 22.6881 16.0081C22.6881 12.3191 19.6952 9.32617 16.0062 9.32617ZM16.0062 20.3425C13.6129 20.3425 11.6718 18.4014 11.6718 16.0081C11.6718 13.6148 13.6129 11.6737 16.0062 11.6737C18.3995 11.6737 20.3405 13.6148 20.3405 16.0081C20.3405 18.4014 18.3995 20.3425 16.0062 20.3425Z"
            fill={fill}
          />
          <path
            d="M24.5125 9.06192C24.5125 9.92575 23.8113 10.6219 22.9525 10.6219C22.0887 10.6219 21.3926 9.92067 21.3926 9.06192C21.3926 8.1981 22.0938 7.50195 22.9525 7.50195C23.8113 7.50195 24.5125 8.20318 24.5125 9.06192Z"
            fill={fill}
          />
        </svg>
      );
    case 'linkedIn':
      return (
        <svg
          width={width}
          height={height}
          viewBox={viewBox}
          fill={fill}
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          data-testid={type}
        >
          <title>{alt}</title>
          <rect width="48" height="48" rx="2" fill="none" />
          <path d="M6 12.334H11.2381V27.0007H6V12.334Z" fill={fill} />
          <path
            d="M6 7.61905C6 8.31366 6.27373 8.97983 6.76096 9.47099C7.2482 9.96216 7.90904 10.2381 8.5981 10.2381C9.28715 10.2381 9.94799 9.96216 10.4352 9.47099C10.9225 8.97983 11.1962 8.31366 11.1962 7.61905C11.1962 6.92443 10.9225 6.25827 10.4352 5.7671C9.94799 5.27593 9.28715 5 8.5981 5C7.90904 5 7.2482 5.27593 6.76096 5.7671C6.27373 6.25827 6 6.92443 6 7.61905V7.61905Z"
            fill={fill}
          />
          <path
            d="M23.2864 27.0001H26.4292C26.5681 27.0001 26.7014 26.9449 26.7996 26.8466C26.8978 26.7484 26.953 26.6152 26.953 26.4763V17.6763C26.953 13.7267 24.7216 11.8096 21.5997 11.8096C20.9839 11.7871 20.3703 11.8938 19.7983 12.123C19.2263 12.3521 18.7086 12.6986 18.2787 13.1401C18.2213 13.2064 18.145 13.2536 18.0599 13.2752C17.9749 13.2969 17.8853 13.2919 17.8032 13.2611C17.721 13.2303 17.6503 13.1751 17.6004 13.1029C17.5506 13.0307 17.5241 12.9449 17.5245 12.8572C17.5245 12.7183 17.4693 12.5851 17.371 12.4868C17.2728 12.3886 17.1396 12.3334 17.0007 12.3334H13.8578C13.7189 12.3334 13.5856 12.3886 13.4874 12.4868C13.3892 12.5851 13.334 12.7183 13.334 12.8572V26.4763C13.334 26.6152 13.3892 26.7484 13.4874 26.8466C13.5856 26.9449 13.7189 27.0001 13.8578 27.0001H17.0007C17.1396 27.0001 17.2728 26.9449 17.371 26.8466C17.4693 26.7484 17.5245 26.6152 17.5245 26.4763V18.6191C17.5245 17.9245 17.8004 17.2583 18.2916 16.7672C18.7827 16.276 19.4489 16.0001 20.1435 16.0001C20.8381 16.0001 21.5043 16.276 21.9955 16.7672C22.4866 17.2583 22.7626 17.9245 22.7626 18.6191V26.4763C22.7626 26.6152 22.8177 26.7484 22.916 26.8466C23.0142 26.9449 23.1474 27.0001 23.2864 27.0001Z"
            fill={fill}
          />
        </svg>
      );
    case 'medium':
      return (
        <svg
          width={width}
          height={height}
          viewBox={viewBox}
          fill={fill}
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          data-testid={type}
        >
          <title>{alt}</title>
          <rect width="48" height="48" rx="2" fill="none" />
          <path
            d="M17.6667 16.4987C17.6667 12.3558 14.3831 9 10.3346 9C6.28613 9 3 12.3584 3 16.4987C3 20.6391 6.28363 24 10.3321 24C14.3806 24 17.6667 20.6416 17.6667 16.4987Z"
            fill={fill}
          />
          <path
            d="M25.7116 16.4996C25.7116 12.5997 24.0697 9.43873 22.0443 9.43873C20.0188 9.43873 18.377 12.5997 18.377 16.4996C18.377 20.3996 20.0188 23.5605 22.0443 23.5605C24.0697 23.5605 25.7091 20.3996 25.7116 16.4996Z"
            fill={fill}
          />
          <path
            d="M28.999 16.4978C28.999 13.0053 28.421 10.1734 27.7085 10.1734C26.996 10.1734 26.418 13.0053 26.418 16.4978C26.418 19.9903 26.996 22.8223 27.7085 22.8223C28.421 22.8223 28.999 19.9928 28.999 16.4978Z"
            fill={fill}
          />
        </svg>
      );
    case 'twitter':
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 -6 16 30"
          fill={fill}
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          data-testid={type}
        >
          <title>{alt}</title>
          <rect width="48" height="48" rx="2" fill="none" />
          <path
            d="M11.9027 8.46864L19.3482 0H17.5838L11.119 7.3532L5.95547 0H0L7.8082 11.1193L0 20H1.76443L8.59152 12.2348L14.0445 20H20L11.9023 8.46864H11.9027ZM9.48608 11.2173L8.69495 10.1101L2.40018 1.29968H5.11025L10.1902 8.40994L10.9813 9.51718L17.5847 18.7594H14.8746L9.48608 11.2177V11.2173Z"
            fill={fill}
          />
        </svg>
      );
    case 'youTube':
      return (
        <svg
          width={width}
          height={height}
          viewBox={viewBox}
          fill={fill}
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          data-testid={type}
        >
          <title>{alt}</title>
          <rect width="48" height="48" rx="2" fill="none" />
          <path
            d="M27.4955 10.6597C27.2227 9.61774 26.4045 8.79516 25.3682 8.50726C23.5 8 16 8 16 8C16 8 8.5 8 6.61818 8.50726C5.58182 8.78145 4.77727 9.60403 4.49091 10.6597C4 12.5516 4 16.5 4 16.5C4 16.5 4 20.4484 4.50455 22.3403C4.77727 23.3823 5.59545 24.2048 6.63182 24.4927C8.5 25 16 25 16 25C16 25 23.5 25 25.3818 24.4927C26.4182 24.2185 27.2227 23.396 27.5091 22.3403C28 20.4484 28 16.5 28 16.5C28 16.5 28 12.5516 27.4955 10.6597ZM13.5455 20.0919V12.9081L19.8182 16.5L13.5455 20.0919Z"
            fill={fill}
          />
        </svg>
      );
    case 'tiktok':
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 18 21"
          fill={fill}
          xmlns="http://www.w3.org/2000/svg"
          className={`${className} ${type}`}
          data-testid={type}
        >
          <title>{alt}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.8729 0.5C13.2001 3.33809 14.7702 5.03015 17.5 5.21015V8.40226C15.918 8.55826 14.5323 8.03624 12.9205 7.05221V13.0224C12.9205 20.6067 4.72506 22.9767 1.43022 17.5406C-0.687043 14.0424 0.609482 7.90424 7.40137 7.65823V11.0243C6.88395 11.1083 6.33085 11.2403 5.82532 11.4144C4.31469 11.9304 3.45827 12.8964 3.69616 14.6005C4.15411 17.8646 10.0896 18.8306 9.59595 12.4524V0.506H12.8729V0.5Z"
            fill={fill}
          />
        </svg>
      );
    case 'threads':
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 19 21"
          fill={fill}
          xmlns="http://www.w3.org/2000/svg"
          className={`${className} ${type}`}
          data-testid={type}
        >
          <title>{alt}</title>
          <path
            d="M14.5066 9.76962C14.4165 9.72832 14.3249 9.68858 14.2322 9.65053C14.0707 6.80606 12.4448 5.1776 9.71466 5.16094C9.70229 5.16086 9.68999 5.16087 9.67762 5.16087C8.04465 5.16087 6.68653 5.82718 5.85062 7.03966L7.3521 8.02425C7.97656 7.11857 8.95659 6.9255 9.67834 6.9255C9.68668 6.9255 9.69504 6.9255 9.70329 6.92557C10.6022 6.93105 11.2806 7.1809 11.7196 7.66813C12.0391 8.02284 12.2528 8.51302 12.3586 9.13165C11.5616 9.00216 10.6996 8.96234 9.7782 9.01284C7.18251 9.15577 5.5138 10.6029 5.62588 12.6138C5.68275 13.6338 6.21432 14.5113 7.12261 15.0845C7.89057 15.5691 8.87964 15.806 9.90758 15.7524C11.2651 15.6813 12.33 15.1861 13.073 14.2808C13.6372 13.5933 13.9941 12.7024 14.1517 11.5798C14.7986 11.953 15.2781 12.4442 15.5429 13.0346C15.9932 14.0382 16.0194 15.6875 14.6116 17.0321C13.3782 18.21 11.8956 18.7196 9.6549 18.7353C7.16938 18.7177 5.28962 17.9557 4.06745 16.4705C2.92299 15.0798 2.33152 13.071 2.30946 10.5C2.33152 7.92894 2.92299 5.92017 4.06745 4.52945C5.28962 3.04426 7.16935 2.28229 9.65487 2.26464C12.1584 2.28243 14.0709 3.04806 15.3399 4.54042C15.9621 5.27225 16.4312 6.19258 16.7405 7.26566L18.5 6.8169C18.1251 5.49606 17.5353 4.35789 16.7326 3.41396C15.1058 1.5007 12.7266 0.520328 9.661 0.5H9.64873C6.58938 0.520257 4.23679 1.50435 2.65632 3.42493C1.24992 5.134 0.524453 7.51205 0.500076 10.493L0.5 10.5L0.500076 10.507C0.524453 13.4879 1.24992 15.866 2.65632 17.5751C4.23679 19.4956 6.58938 20.4798 9.64873 20.5H9.661C12.3809 20.482 14.2981 19.8013 15.8775 18.2928C17.9439 16.3194 17.8817 13.8457 17.2006 12.3272C16.712 11.2382 15.7805 10.3538 14.5066 9.76962ZM9.8104 13.9903C8.67276 14.0516 7.49087 13.5634 7.43259 12.5179C7.38939 11.7427 8.00971 10.8777 9.88021 10.7747C10.0944 10.7629 10.3046 10.7571 10.5111 10.7571C11.1906 10.7571 11.8262 10.8202 12.404 10.9409C12.1885 13.5141 10.9242 13.9319 9.8104 13.9903Z"
            fill={fill}
          />
        </svg>
      );
    default:
      return null;
  }
};

const SocialIconAtom = styled(SocialIcon)``;

export default SocialIconAtom;
